export type TaskNavigationInfo = {
    module: string;
    task: string;
    "?query"?: Record<string, string>;
}